import { IComponentOptions } from "angular";
import { SelectContractModalController } from "./controller";

export const vsComponentName = "selectContractModalComponent";

export const selectContractModalComponentOptions: IComponentOptions = {
  controller: SelectContractModalController,
  controllerAs: "componentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    modalInstance: "=",
    resolve: "=",
  },
};
